import React from 'react';
import { motion } from 'framer-motion';
const MAIL_HREF = 'https://mail.google.com/mail/?view=cm&fs=1&to=contact@birdiebagco.com';
export function Legal() {
  return <>
      {/* Terms & Conditions */}
      <section id="terms" className="py-20 md:py-28 px-4 bg-white" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto" data-id="element-79">
          <div className="text-xs uppercase tracking-[0.25em] text-green font-medium mb-4" data-id="element-80">
            The fine print
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-charcoal mb-8" data-id="element-81">
            Terms & Conditions
          </h2>

          <div className="space-y-8 text-charcoal/70 leading-relaxed" data-id="element-82">
            <p className="text-sm text-charcoal/50" data-id="element-83">Last updated: June 2026</p>

            <div data-id="element-84">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-85">
                1. About Birdie Bag
              </h3>
              <p data-id="element-86">
                Birdie Bag ("we", "us", "our") designs and sells handcrafted,
                3D-printed reusable straw caddies and accessories. By placing an
                order or using this website, you agree to these terms.
              </p>
            </div>

            <div data-id="element-87">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-88">
                2. Products & Pricing
              </h3>
              <p data-id="element-89">
                All prices are listed in pounds sterling (£) and include
                applicable taxes unless stated otherwise. Optional engraving is
                available for an additional £4.99, and the Family Pack upgrade
                is available for an additional £4.99. We reserve the right to
                update prices and product details at any time.
              </p>
            </div>

            <div data-id="element-90">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-91">
                3. Personalized & Engraved Items
              </h3>
              <p data-id="element-92">
                Engraved products are made to order based on the name you
                provide (up to 8 characters). Because these items are custom,
                they cannot be cancelled or returned once production has begun,
                except where the item arrives faulty or damaged. Please
                double-check spelling before ordering.
              </p>
            </div>

            <div data-id="element-93">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-94">
                4. Orders & Shipping
              </h3>
              <p data-id="element-95">
                Orders are produced and dispatched within a reasonable
                timeframe. Delivery times may vary by destination. Risk of loss
                passes to you upon delivery. We are not liable for delays caused
                by carriers or events outside our control.
              </p>
            </div>

            <div data-id="element-96">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-97">
                5. Returns & Refunds
              </h3>
              <p data-id="element-98">
                Non-personalized items may be returned within 14 days of receipt
                in their original, unused condition. Engraved and personalized
                items are exempt unless faulty. To start a return, contact us at{' '}
                <a href={MAIL_HREF} target="_blank" rel="noopener noreferrer" className="text-green hover:underline" data-id="element-99">
                  contact@birdiebagco.com
                </a>
                .
              </p>
            </div>

            <div data-id="element-100">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-101">
                6. Intellectual Property
              </h3>
              <p data-id="element-102">
                All branding, designs, imagery, and content on this site are the
                property of Birdie Bag and may not be reproduced without
                permission.
              </p>
            </div>

            <div data-id="element-103">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-104">
                7. Contact
              </h3>
              <p data-id="element-105">
                Questions about these terms? Reach us any time at{' '}
                <a href={MAIL_HREF} target="_blank" rel="noopener noreferrer" className="text-green hover:underline" data-id="element-106">
                  contact@birdiebagco.com
                </a>
                .
              </p>
            </div>
          </div>
        </motion.div>
      </section>

      {/* Privacy Policy */}
      <section id="privacy" className="py-20 md:py-28 px-4 bg-cream" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto" data-id="element-108">
          <div className="text-xs uppercase tracking-[0.25em] text-green font-medium mb-4" data-id="element-109">
            Your privacy
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-charcoal mb-8" data-id="element-110">
            Privacy Policy
          </h2>

          <div className="space-y-8 text-charcoal/70 leading-relaxed" data-id="element-111">
            <p className="text-sm text-charcoal/50" data-id="element-112">Last updated: June 2026</p>

            <div data-id="element-113">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-114">
                1. Information We Collect
              </h3>
              <p data-id="element-115">
                When you place an order or contact us, we may collect your name,
                email address, shipping address, engraving details, and order
                information. We only collect what we need to fulfil your order
                and respond to your enquiries.
              </p>
            </div>

            <div data-id="element-116">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-117">
                2. How We Use Your Information
              </h3>
              <p data-id="element-118">
                We use your information to process and ship orders, provide
                customer support, and — only if you opt in — share occasional
                updates. We never sell your personal data.
              </p>
            </div>

            <div data-id="element-119">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-120">
                3. Payment Data
              </h3>
              <p data-id="element-121">
                Payments are handled by trusted third-party payment processors.
                We do not store your full card details on our servers.
              </p>
            </div>

            <div data-id="element-122">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-123">
                4. Cookies
              </h3>
              <p data-id="element-124">
                Our website may use essential cookies to make the site function
                and, with your consent, analytics cookies to help us improve.
                You can manage cookies through your browser settings.
              </p>
            </div>

            <div data-id="element-125">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-126">
                5. Your Rights
              </h3>
              <p data-id="element-127">
                You have the right to access, correct, or request deletion of
                your personal data, and to withdraw consent for marketing at any
                time. To exercise these rights, email us at{' '}
                <a href={MAIL_HREF} target="_blank" rel="noopener noreferrer" className="text-green hover:underline" data-id="element-128">
                  contact@birdiebagco.com
                </a>
                .
              </p>
            </div>

            <div data-id="element-129">
              <h3 className="font-display text-xl font-bold text-charcoal mb-2" data-id="element-130">
                6. Contact
              </h3>
              <p data-id="element-131">
                For any privacy questions, please contact us at{' '}
                <a href={MAIL_HREF} target="_blank" rel="noopener noreferrer" className="text-green hover:underline" data-id="element-132">
                  contact@birdiebagco.com
                </a>
                .
              </p>
            </div>
          </div>
        </motion.div>
      </section>
    </>;
}